<template>
  <NotFound v-if="typeCheck === 'error'" />
  <main
      :class="{
      'main-content-area': true,
      'pt-65': pageMenuBlock,
      'pt-26': !pageMenuBlock,
    }"
      v-else
  >
    <section class="ct-article">
      <div class="container">
        <!--Breadcrumps-->
        <div class="col-md-12">
          <Breadcrumb :breadcrumbData="breadCrumb" :dark="true" />
        </div>
        <!--End Breadcrumps-->
      </div>
    </section>
    <!-- Editor Section -->
    <template>
      <section class="ct-editor-section pb-25">
        <div class="container pb-25 overflow-auto">
          <h1 class="custom-font-1">
            {{ streamsData.title }}
          </h1>

          <div class="wp-has-aspect-ratio ratio-16-9" v-if="videoId">
            <iframe
              :src="`https://player.twitch.tv/?video=${videoId}&parent=${host}&autoplay=false`"
              height="100%"
              width="100%"
              allowfullscreen
            >
            </iframe>
          </div>
        </div>
        <template v-for="(data, index) in tabData">
          <template v-if="
            data.blockName === 'wpvcb/page-menu-blocks-scroll' &&
            data.filtered_content &&
            Object.keys(data.filtered_content).length > 0 &&
            data.filtered_content.menu.length > 0">
            <div id="sticky-nav"
                 :style="{ top: stickyNavTop }"
                 :key="`${data.blockName}-${index}`">
              <div class="review-top-menu" v-if="showSticky">
                <nav class="scroll-nav">
                  <span
                      v-for="(mn, index) in data.filtered_content.menu"
                      :key="index"
                      @click="scrollPage(mn.menu_block_id)"
                      :class="{
                      'scroll-item': true,
                      active: activeKey === mn.menu_block_id,
                    }"
                      :style="{ '--bg-clr': $root.color_schema.primary_btn }">
                    {{ mn.menu_name }}
                  </span>
                </nav>
              </div>
            </div>
          </template>
          <div :ref="
                data.attrs &&
                Object.keys(data.attrs).length > 0 &&
                data.attrs.blockID &&
                data.attrs.blockID != ''
                  ? `${data.attrs.blockID}`
                  : ''
              "
               :key="`${data.blockName}-${index}`">
            <CustomComponent
                :blockData="data"
                :recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
                :bluebar="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? bluebar : {}"
                :blockIndex="index"
            />
          </div>
        </template>
      </section>
    </template>
    <!-- Editor Section Ends -->

    <!--Related Page Links-->
    <template v-if="morePaymentBottom">
      <RelatedLinks :relatedLinkData="morePaymentBottom" />
    </template>
    <!--End Related Page Links-->

    <!--Author Block-->
    <template v-if="auhtorBlockdata"> </template>
    <!--End Author Block-->
  </main>
</template>

<script>
import CustomComponent from '@/components/CustomComponent';
import Breadcrumb from "@/components/layouts/Breadcrumb";
import RelatedLinks from "@/components/custom-block/RelatedLinks";
import NotFound from "@/pages/404";

import { getLang } from "@/misc/lang";
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";
import { metaChanger } from "@/misc/meta-changer";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "Streams",
  props: ["streamsData"],
  components: {
    Breadcrumb,
    CustomComponent,
    RelatedLinks,
    NotFound
  },
  data() {
    return {
      pageAttr: {
        type: Object,
        default: () => {},
      },
      pageData: {
        type: Object,
        default: () => {},
      },
      tabData: {},
      supportEmail: "",
      contactName: "",
      contactNumber: "",
      breadCrumb: {
        type: Array,
        default: () => [],
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      supportedLang: {
        type: Array,
        default: () => [],
      },
      showHideObj: {
        spTop: false,
        pmTop: false,
        liscTop: false,
        spMidSc: false,
        liscUnderSc: false,
        dipositSc: false,
        withdrawSc: false,
      },
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      activeKey: "",
      scrollOffset: 0,
      metaData: "",
      busy: false,
      pageIndex: 0,
      stickyNavTop: 0,
      showSticky: true,
      clickCount: 0,
      topStickyHeight: 0,
      topHeaderStickyHeight: 0,
      hideBonusLabel: false,
      hideToplistLabel: false,
      pageMenuBlock: [],
      auhtorBlockdata: [],
      rightBlockdata: [],
      scriptFlag: 0,
      typeCheck: "",
      host: "",
      videoId: "",
    };
  },
  methods: {
    pSBC,
    getContrastYIQ,
    metaChanger,
    getOffset,
    getLang,
    getHeightHeader: function () {
      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("sticky-nav")) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("header")) {
                this.stickyNavTop = `${
                    document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                    document.getElementById("panel-wrapper").offsetHeight +
                    document.getElementById("header").offsetHeight -
                    10
                }px`;
              } else {
                this.stickyNavTop = `${
                    document.getElementById("panel-wrapper").offsetHeight +
                    document.getElementById("sticky-regulation-banner")
                        .offsetHeight
                }px`;
              }
            } else {
              if (document.getElementById("regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = `${
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("regulation-banner").offsetHeight +
                      document.getElementById("header").offsetHeight -
                      10
                  }px`;
                } else {
                  this.stickyNavTop = `${
                      document.getElementById("regulation-banner").offsetHeight +
                      document.getElementById("panel-wrapper").offsetHeight
                  }px`;
                }
              } else {
                if (document.getElementById("header")) {
                  this.stickyNavTop = `${
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("header").offsetHeight -
                      10
                  }px`;
                } else {
                  this.stickyNavTop = `${
                      document.getElementById("panel-wrapper").offsetHeight
                  }px`;
                }
              }
            }
          }
        } else {
          if (document.getElementById("sticky-nav")) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("header")) {
                this.stickyNavTop = `${
                    document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                    document.getElementById("header").offsetHeight -
                    10
                }px`;
              } else {
                this.stickyNavTop = `${
                    document.getElementById("sticky-regulation-banner")
                        .offsetHeight
                }px`;
              }
            } else {
              if (document.getElementById("regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = `${
                      document.getElementById("regulation-banner").offsetHeight +
                      document.getElementById("header").offsetHeight -
                      10
                  }px`;
                } else {
                  this.stickyNavTop =
                      document.getElementById("regulation-banner").offsetHeight +
                      0;
                }
              } else {
                if (document.getElementById("header")) {
                  this.stickyNavTop = `${
                      document.getElementById("header").offsetHeight - 10
                  }px`;
                } else {
                  this.stickyNavTop = 0;
                }
              }
            }
          }
        }
      } else {
        if (
            this.$root.show_stickymenu &&
            this.$root.show_stickymenu_mobile &&
            window.innerWidth < 992
        ) {
          this.stickyNavTop = 70;
        }
      }
    },
    getHeightHeaderScroll: function () {
      if (window.pageYOffset > 10) {
        if (window.innerWidth > 991) {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = `${
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-header").offsetHeight
                  }px`;
                } else {
                  this.stickyNavTop = `${
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight
                  }px`;
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = `${
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-header").offsetHeight
                  }px`;
                } else {
                  this.stickyNavTop = `${
                      document.getElementById("panel-wrapper").offsetHeight
                  }px`;
                }
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = `${
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                      document.getElementById("sticky-header").offsetHeight
                  }px`;
                } else {
                  this.stickyNavTop = `${
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight
                  }px`;
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  this.stickyNavTop = `${
                      document.getElementById("sticky-header").offsetHeight
                  }px`;
                } else {
                  this.stickyNavTop = 0;
                }
              }
            }
          }
        } else {
          if (
              this.$root.show_stickymenu &&
              this.$root.show_stickymenu_mobile &&
              window.innerWidth < 992
          ) {
            this.stickyNavTop = 70;
          }
        }
      } else {
        if (window.innerWidth > 991) {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = `${
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("header").offsetHeight -
                      10
                  }px`;
                } else {
                  this.stickyNavTop = `${
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight
                  }px`;
                }
              } else {
                if (document.getElementById("regulation-banner")) {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = `${
                        document.getElementById("panel-wrapper").offsetHeight +
                        document.getElementById("regulation-banner")
                            .offsetHeight +
                        document.getElementById("header").offsetHeight -
                        10
                    }px`;
                  } else {
                    this.stickyNavTop = `${
                        document.getElementById("regulation-banner")
                            .offsetHeight +
                        document.getElementById("panel-wrapper").offsetHeight
                    }px`;
                  }
                } else {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = `${
                        document.getElementById("panel-wrapper").offsetHeight +
                        document.getElementById("header").offsetHeight -
                        10
                    }px`;
                  } else {
                    this.stickyNavTop = `${
                        document.getElementById("panel-wrapper").offsetHeight
                    }px`;
                  }
                }
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("header")) {
                  this.stickyNavTop = `${
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                      document.getElementById("header").offsetHeight -
                      10
                  }px`;
                } else {
                  this.stickyNavTop = `${
                      document.getElementById("sticky-regulation-banner")
                          .offsetHeight
                  }px`;
                }
              } else {
                if (document.getElementById("regulation-banner")) {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = `${
                        document.getElementById("regulation-banner")
                            .offsetHeight +
                        document.getElementById("header").offsetHeight -
                        10
                    }px`;
                  } else {
                    this.stickyNavTop =
                        document.getElementById("regulation-banner")
                            .offsetHeight + 0;
                  }
                } else {
                  if (document.getElementById("header")) {
                    this.stickyNavTop = `${
                        document.getElementById("header").offsetHeight - 10
                    }px`;
                  } else {
                    this.stickyNavTop = 0;
                  }
                }
              }
            }
          }
        } else {
          if (
              this.$root.show_stickymenu &&
              this.$root.show_stickymenu_mobile &&
              window.innerWidth < 992
          ) {
            this.stickyNavTop = 70;
          }
        }
      }
    },
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    getBonusShowHide: function (partner) {
      let hideBonus = this.getCASToplistShowHideData(partner);
      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
    updateBonusHeight: function () {
      let heightArr = [];
      document.querySelectorAll(".sticky-inner").forEach((ele) => {
        heightArr.push(ele.clientHeight);
      });
      this.topStickyHeight = Math.max(...heightArr);
      if (document.getElementById("review-sticky-card")) {
        if (window.innerWidth > 991) {
          document.getElementById("review-sticky-card").style.top = `-${
              this.topStickyHeight + 1
          }px`;
        } else {
          document.getElementById("review-sticky-card").style.top = null;
        }
      }

      this.topHeaderStickyHeight = document.getElementById("sticky-header")
          ? document.getElementById("sticky-header").offsetHeight
          : 0;
      document.querySelectorAll(".sticky-review-card").forEach((ele) => {
        ele.style.height = `${Math.max(...heightArr)}px`;
      });
    },
    loadMore: function () {
      this.busy = true;
      this.pageIndex++;

      this.busy = false;
    },
    getPageData: function () {
      HttpService.getBody(
          this.$root.wp_country && this.$root.wp_country != ""
              ? this.$root.wp_country
              : this.$cookies.get("wp-country"),
          this.$root.wp_state && this.$root.wp_state != ""
              ? this.$root.wp_state
              : this.$cookies.get("wp-state"),
          this.$route.params.postSlug,
          this.$root.user_id
      )
          .then((res) => {
            this.pageAttr = res.data.data.attrs;

            this.tabData = res.data.data.content.blocks;

            this.breadCrumb = res.data.data.breadcrumb;
            this.pageMenuBlock =
                this.tabData
                    .map((ele) => ele.blockName)
                    .indexOf("wpvcb/page-menu-blocks-scroll") > -1;
            // More Payments Bottom Card
            this.morePaymentBottom = res.data.data.meta.more_payment_method;

            // Author Blocks Filtered
            let atBlock = res.data.data.content.blocks.filter((ele) => {
              if (ele.blockName === "wpvcb/author-block") {
                return ele.filtered_content;
              }
            });
            if (atBlock.length > 0)
              this.auhtorBlockdata = atBlock.shift().filtered_content;

            // RightContent Blocks Filtered
            let rightBlock = res.data.data.content.blocks.filter((ele) => {
              if (ele.blockName === "wpvcb/right-content-simpletoc") {
                return ele.filtered_content;
              }
            });
            if (rightBlock.length > 0)
              this.rightBlockdata = rightBlock.shift().filtered_content;

            // Schema Append
            document.getElementById("schema-script").innerHTML =
                res.data.data.schema;

            // Adminbar Data
            this.$root.adminBarData =
                Object.keys(res.data.data.toolbar).length > 0
                    ? res.data.data.toolbar
                    : "";
            this.$root.disable = this.$root.adminBarData
                ? this.$root.adminBarData.visible
                : false;

            // Assets Sizes
            this.assets_images =
                Object.keys(this.$root.asset_sizes).length > 0
                    ? this.$root.asset_sizes
                    : "";

            if (
                this.tabData.length === 0 ||
                (this.tabData &&
                    this.tabData.filter((ele) => ele.tab_content).length === 0)
            ) {
              this.pageIndex = 2;
            }

            if (!this.$root.enable_lazyload) {
              this.pageIndex = 2;
              this.$root.show_footer = true;
            } else {
              this.$root.show_footer = false;
            }
            this.$root.loading = false;

            if (
                this.scriptFlag === 0 &&
                res.data.data.content.blocks.filter((ele) => {
                  return (
                      ele.blockName === "wpvcb/custom-youtube" ||
                      ele.blockName === "wpvcb/youtube-film-strip"
                  );
                }).length > 0
            ) {
              this.youtubeInit();
              this.scriptFlag++;
            }
          })
          .catch((err) => {
            this.typeCheck = "error";
            this.$root.loading = false;
          });
    },
    scrollPage: function (ref) {
      if (this.activeKey === "") {
        this.activeKey = ref;
        let tabTop = 0;
        if (this.$root.show_stickymenu && this.$root.show_stickymenu_desktop) {
          tabTop = this.getOffset(this.$refs[ref][0]).top - 30;
        } else {
          tabTop = this.getOffset(this.$refs[ref][0]).top + 90;
        }
        window.scrollTo({
          top: tabTop - 200,
          behavior: "smooth",
        });
      } else {
        if (this.activeKey != ref) {
          this.activeKey = ref;
          let tabTop = 0;
          if (
              this.$root.show_stickymenu &&
              this.$root.show_stickymenu_desktop
          ) {
            tabTop = this.getOffset(this.$refs[ref][0]).top;
          } else {
            tabTop = this.getOffset(this.$refs[ref][0]).top + 120;
          }
          window.scrollTo({
            top: tabTop - 180,
            behavior: "smooth",
          });
        }
      }
    },
  },
  created: function () {
    if (
        this.$root.routes_meta[this.$route.params.postSlug] &&
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
          this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );

    if (this.streamsData != undefined) {
      this.pageAttr = this.streamsData.attrs;

      this.tabData = this.streamsData.content.blocks;

      this.breadCrumb = this.streamsData.breadcrumb;
      this.pageMenuBlock =
          this.tabData
              .map((ele) => ele.blockName)
              .indexOf("wpvcb/page-menu-blocks-scroll") > -1;

      // More Payments Bottom Card
      this.morePaymentBottom = this.streamsData.meta.more_payment_method;

      // Author Blocks Filtered
      let atBlock = this.streamsData.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0)
        this.auhtorBlockdata = atBlock.shift().filtered_content;

      // RightContent Blocks Filtered
      let rightBlock = this.streamsData.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0)
        this.rightBlockdata = rightBlock.shift().filtered_content;

      // Schema Append
      document.getElementById("schema-script").innerHTML = this.streamsData.schema;

      // Adminbar Data
      this.$root.adminBarData =
          Object.keys(this.streamsData.toolbar).length > 0
              ? this.streamsData.toolbar
              : "";
      this.$root.disable = this.$root.adminBarData
          ? this.$root.adminBarData.visible
          : false;

      // Assets Sizes
      this.assets_images =
          Object.keys(this.$root.asset_sizes).length > 0
              ? this.$root.asset_sizes
              : "";

      if (
          this.tabData.length === 0 ||
          (this.tabData &&
              this.tabData.filter((ele) => ele.tab_content).length === 0)
      ) {
        this.pageIndex = 2;
      }

      if (!this.$root.enable_lazyload) {
        this.pageIndex = 2;
        this.$root.show_footer = true;
      } else {
        this.$root.show_footer = false;
      }
      if (
          this.scriptFlag === 0 &&
          this.streamsData.content.blocks.filter((ele) => {
            return (
                ele.blockName === "wpvcb/custom-youtube" ||
                ele.blockName === "wpvcb/youtube-film-strip"
            );
          }).length > 0
      ) {
        this.youtubeInit();
        this.scriptFlag++;
      }
    } else {
      this.$root.loading = true;
      this.getPageData();
    }
    
    this.videoId = this.streamsData.video_id;
    this.host = location.host;
  },
  mounted: function () {
    this.$nextTick(() => {
      this.heightCheck();
      this.updateBonusHeight();
      this.getHeightHeader();
    });

    let refOffsetTop = [];
    if (this.pageMenuBlock) {
      window.addEventListener(
          "scroll",
          () => {
            if (!(refOffsetTop.length > 0)) {
              for (let ref in that.$refs) {
                if (ref != "") {
                  if (
                      this.$root.show_stickymenu &&
                      this.$root.show_stickymenu_desktop
                  ) {
                    refOffsetTop.push({
                      ref: ref,
                      offset: that.getOffset(that.$refs[ref][0]).top - 60,
                    });
                  } else {
                    refOffsetTop.push({
                      ref: ref,
                      offset: that.getOffset(that.$refs[ref][0]).top + 60,
                    });
                  }
                }
              }
            }
            let pageOffset = window.pageYOffset + 180;
            let tabArray = [];
            refOffsetTop.forEach((ele) => {
              if (ele.offset <= pageOffset) {
                tabArray.push(ele.ref);
              }
            });
            if (tabArray.length > 0) {
              that.activeKey = tabArray[tabArray.length - 1];
            }
          },
          { passive: true }
      );
    }
    var that = this;
    window.addEventListener(
        "scroll",
        function () {
          that.getHeightHeaderScroll();
          //that.heightCheck();
        },
        { passive: true }
    );
    window.addEventListener(
        "scroll",
        () => {
          that.heightCheck();
        },
        {
          passive: true,
        }
    );
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
      that.getHeightHeader();
      let windowWidth = window.innerWidth;
      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }
    });
  },
  beforeDestroy: function () {
    window.removeEventListener(
        "scroll",
        () => {
          that.heightCheck();
        },
        {
          passive: true,
        }
    );
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });
    if (window.innerWidth > 991) {
      document.getElementById("sticky-header")
          ? (document.getElementById("sticky-header").style.top = "0")
          : "";
    }
  },
  watch: {
    "$route.params.postSlug": function () {
      if (this.streamsData != undefined) {
      } else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    pageIndex: function () {
      if (this.pageIndex > 3) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.lang-img {
  height: 36px;
  width: 36px;
}

.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.pb-1 {
  padding-top: 1px !important;
}

.ct {
  &-inner-banner {
    padding: 0px 0 45px;
    background: #070438 url(~@/assets/images/top-bg.svg) no-repeat 0 0;
    .game-space {
      position: relative;
      min-height: 321px;
      @media (min-width: @sizes[extra-small]) {
        min-height: auto;
      }
      img {
        border-radius: 10px;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
        height: 100%;
        object-fit: cover;
        width: auto;
        max-height: 321px;
        min-height: 321px;
        @media (min-width: @sizes[extra-small]) {
          width: 100%;
          max-height: none;
          min-height: auto;
        }
      }
      &-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 20px;
        .display-flex();
        .align-items(center);
        .justify-content-center();
        .flex-direction-column();
        .button-block {
          .display-flex();
          .align-items(center);
          .justify-content-center();
          .flex-direction-column();
          width: 100%;
          margin-bottom: 15px;
          .cta {
            min-width: 100%;
            margin: 5px 0;
            font-weight: bold;
            font-size: 14px;
            line-height: 17px;
            padding: 10px 18px;
            @media (min-width: @sizes[medium]) {
              min-width: 330px;
              margin: 10px 0;
              padding: 15px 18px;
              font-size: 18px;
              line-height: 22px;
            }
          }
        }
        .game-logo {
          img {
            box-shadow: none;
            max-height: none;
            min-height: auto;
          }
        }
      }
    }
    .row {
      .col-md-8 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 66.66666667%;
          float: left;
        }
      }
      .col-md-4 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 33.33333333%;
          float: left;
        }
      }
    }
    &-lft {
      margin-bottom: 19px;
      @media (min-width: @sizes[large]) {
        margin-bottom: 0;
      }
      @media (min-width: @sizes[extraX-large]) {
        width: 906px !important;
      }
    }
    &-rgt {
      @media (min-width: @sizes[extraX-large]) {
        width: 314px !important;
      }
    }
  }
}

.new-review-banner {
  &-card {
    padding: 12px 16px;
    .border-radius(12px);
    box-shadow: none;
    @media (min-width: @sizes[small]) {
      padding: 20px;
    }
    @media (min-width: @sizes[md-large]) {
      padding: 30px;
    }
    &-top {
      .display-flex();
      .flex-wrap(nowrap);
      .flex-direction-column();
      @media (min-width: @sizes[medium]) {
        .flex-wrap(wrap);
        .flex-direction-row();
      }
      &-left {
        .display-flex();
        .align-items-flex-start();
        .justify-content-center();
        width: auto;
        margin: 0 -7px 18px -6px;
        @media (min-width: @sizes[custom-small]) {
          margin: 0 -7px 18px 5px;
          justify-content: unset !important;
        }
        @media (min-width: @sizes[small]) {
          width: 100%;
          margin: 0 0px 28px;
          .justify-content-flex-start();
        }
        @media (min-width: @sizes[medium]) {
          margin: 0 0px 45px;
        }
        @media (min-width: @sizes[tablet]) {
          width: calc(100% - 400px);
          margin: 0 0px 5px;
        }
        @media (min-width: @sizes[sm-large]) {
          width: calc(100% - 430px);
        }
        @media (min-width: @sizes[md-large]) {
          width: calc(100% - 495px);
        }
        .review-left-img {
          min-width: 79px;
          max-width: 79px;
          height: 79px;
          background: @white;
          .border-radius(12px);
          .display-flex();
          .align-items(center);
          .justify-content-center();
          position: relative;
          a {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
            border-radius: 12px;
            overflow: visible;
            margin-top: 0px;
            @media (min-width: @sizes[medium]) {
              margin-top: 4px;
            }
            @media (min-width: @sizes[sm-large]) {
              margin-top: 4px;
            }
            @media (min-width: @sizes[md-large]) {
              margin-top: 0px;
            }
          }
          img {
            .border-radius(12px);
            @media (min-width: @sizes[medium]) {
              height: 100%;
              width: 100%;
            }
          }
          @media (min-width: @sizes[medium]) {
            min-width: 245px;
            max-width: 245px;
            height: 245px;
          }
          @media (min-width: @sizes[sm-large]) {
            min-width: 245px;
            max-width: 245px;
            height: 245px;
          }
          @media (min-width: @sizes[md-large]) {
            min-width: 250px;
            max-width: 250px;
            height: 250px;
          }
          .exclusive-tag {
            //display: block;
            position: absolute;
            //bottom: 4px;
            left: 0;
            right: 0;
            margin: auto;
            //width: 67px;
            height: 20px;
            font-size: 12px;
            line-height: 15px;
            //border-radius: 8px;
            width: 100%;
            bottom: 0;
            border-radius: 0;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            @media (min-width: @sizes[medium]) {
              //display: none;
              bottom: 14px;
              width: 210px;
              height: 28px;
              font-size: 17px;
              line-height: 28px;
              z-index: 10;
              border-radius: 8px;
            }
            img {
              width: 18px !important;
              height: 18px !important;
              border-radius: 0 !important;
              vertical-align: initial !important;
              object-fit: contain !important;
              @media (max-width: @sizes[small]) {
                margin: 0px auto;
                width: 14px !important;
                height: 14px !important;
              }
            }
            p {
              @media (min-width: @sizes[small]) {
                font-weight: bold;
                margin-top: 0px;
                font-size: 12px;
                margin: 0;
              }
            }
            svg,
            img {
              @media (max-width: @sizes[medium]) {
                width: 12px;
              }
            }
          }
        }
        .review-left-content {
          padding: 10px 0 5px 15px;
          height: 100%;
          @media (min-width: @sizes[medium]) {
            padding: 0 30px;
          }
          .approve {
            font-weight: normal;
            font-size: 12px;
            line-height: 15px;
            color: @mid-gray;
            margin-bottom: 8px;
            margin-top: 10px;
            display: block;
            i {
              margin-right: 5px;
              @media (min-width: @sizes[small]) {
                margin-right: 7px;
              }
            }
            @media (min-width: @sizes[small]) {
              font-size: 14px;
              line-height: 17px;
              color: @lightestp;
            }
          }
          .exclusive-bar {
            .display-flex();
            .align-items(start);
            .flex-direction-column();
            .flex-wrap(wrap);
            margin-bottom: 0px;
            margin-top: 0px;
            @media (min-width: @sizes[medium]) {
              margin-bottom: 4px;
              margin-top: 0px;
            }
            @media (min-width: @sizes[sm-large]) {
              .align-items(start);
              .flex-direction-column();
              margin-bottom: 4px;
              margin-top: 0px;
            }
            @media (min-width: @sizes[md-large]) {
              .flex-direction-row();
              .align-items(center);
              margin-bottom: 4px;
              margin-top: 0px;
            }
            p {
              margin-bottom: 4px;
              font-weight: 400;
              color: @lightdark;
              padding-right: 7px;
              @media (min-width: @sizes[small]) {
                margin-bottom: 0;
              }
            }
            .exclusive-tag {
              margin-left: 30px;
              display: none;
              @media (min-width: @sizes[medium]) {
                display: none;
              }
            }
            &-rating {
              .display-flex();
              .align-items(center);
              width: 100%;
            }
            &-title {
              .display-flex();
              .flex-direction-column();
              width: 100%;
              @media (min-width: @sizes[medium]) {
                .flex-direction-row();
              }
              p {
                -webkit-box-ordinal-group: 3;
                -ms-flex-order: 2;
                order: 2;
                margin-bottom: 4px;
                margin-top: 4px;
                @media (min-width: @sizes[medium]) {
                  -webkit-box-ordinal-group: 2;
                  -ms-flex-order: 1;
                  order: 1;
                  margin-bottom: 4px;
                }
              }
              .trust {
                .display-flex();
                .align-items(center);
                margin-left: 0px;
                -webkit-box-ordinal-group: 2;
                -ms-flex-order: 1;
                order: 1;
                margin-bottom: 5px;
                @media (min-width: @sizes[medium]) {
                  margin-left: 8px;
                  -webkit-box-ordinal-group: 3;
                  -ms-flex-order: 2;
                  order: 2;
                  margin-bottom: 0;
                }
                strong {
                  font-weight: bold;
                  font-size: 10px;
                  line-height: 1;
                  text-transform: uppercase;
                  color: #4caf50;
                }
                i {
                  background: #4caf50;
                  width: 8.35px;
                  height: 8.35px;
                  .border-radius(2px);
                  .display-inline-flex();
                  .align-items(center);
                  .justify-content-center();
                  margin-right: 3.65px;
                }
              }
            }
          }
          &-title {
            h1 {
              margin-bottom: 12px;
              @media (min-width: @sizes[sm-large]) {
                margin-bottom: 12px;
              }
            }
            .cta {
              min-width: 100%;
            }
            display: none;
            @media (min-width: @sizes[medium]) {
              display: block;
            }
          }
        }
      }
      .view-mob {
        display: block;
        text-align: center;
        h1 {
          margin-bottom: 17px;
          padding: 0 10%;
        }
        .cta-promo-review {
          font-size: 18px;
          line-height: 100%;
          margin-top: 0px;
          display: block;
        }
        @media (min-width: @sizes[medium]) {
          display: none;
        }
      }
      &-right {
        min-width: 100%;
        margin-top: 17px;
        border-top: 0;
        border-right: 0;
        border-left: 0;
        padding: 0;
        @media (min-width: @sizes[medium]) {
          width: calc(100% - 315px);
          min-width: calc(100% - 315px);
          border-right: 1px solid #e5e5e5;
          border-left: 0;
          padding: 0px 45px 0 0;
          margin-top: 0;
        }
        @media (min-width: @sizes[tablet]) {
          width: 400px;
          min-width: auto;
          padding: 0px 0 0 35px;
          border-right: 0;
          border-left: 1px solid #e5e5e5;
        }
        @media (min-width: @sizes[sm-large]) {
          width: 430px;
        }
        @media (min-width: @sizes[md-large]) {
          width: 495px;
        }
        h6 {
          margin-bottom: 3px;
          color: @gray-dimmer;
          @media (min-width: @sizes[small]) {
            margin: 0 0 3px 0;
            color: @lightdark;
          }
        }
        p {
          color: @gray-dimmer;
          @media (min-width: @sizes[small]) {
            margin: 0 0 20px 0;
            color: @mob-gray;
          }
        }
      }
    }
    &-bottom {
      .display-flex();
      .align-items(start);
      .justify-content-flex-start();
      .flex-direction-column();
      border-top: 0;
      padding: 16px 0 0;
      min-width: 100%;
      width: 100%;
      @media (min-width: @sizes[medium]) {
        padding: 0 0 0 45px;
        margin-top: 0px;
        .flex-direction-column();
        min-width: 315px;
        width: 315px;
      }
      @media (min-width: @sizes[tablet]) {
        border-top: 1px solid #e5e5e5;
        width: 100%;
        min-width: auto;
        padding: 24px 0 0;
        margin-top: 32px;
        .flex-direction-row();
      }
      .casino-card-lists {
        margin-bottom: 0px;
        @media (min-width: @sizes[medium]) {
          margin-bottom: 10px;
        }
        @media (min-width: @sizes[md-large]) {
          margin-bottom: 0;
        }
        &:nth-child(2) {
          ul {
            li {
              margin-right: 15px;
              &:last-child {
                margin-right: 0;
              }
              @media (min-width: @sizes[large]) {
                margin-right: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.ct {
  &-editor-section {
    .container {
      position: static;
    }
  }
}

.editor-content {
  .max-cntent-area {
    max-width: 960px;
  }
  h1 {
    line-height: 44px;
  }
  img {
    margin-bottom: 20px;
  }
  ul {
    list-style-type: none;
    padding: 0;
    li {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 25px;
      position: relative;
      padding-left: 20px;
      margin-bottom: 15px;
      span {
        font-weight: 700;
      }
    }
  }
}

#sticky-nav {
  //padding-bottom: 30px;
  position: -webkit-sticky;
  position: fixed;
  width: 100%;
  border-bottom: 1px solid @border-gray;
  z-index: 10;
}

.review-top-menu {
  padding-bottom: 30px;
  padding-top: 14px;
  background: @white;
  border-bottom: 1px solid @border-gray;
  margin: 0 -15px 0px;
  padding: 0 14px;
  height: 53px;
  .scroll-nav {
    .display-flex();
    .align-items(center);
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    max-width: 1210px;
    margin: 0 auto;
    height: 53px;
    .scroll-item {
      margin-right: 30px;
      display: inline-block;
      padding: 10px 0px;
      position: relative;
      font-weight: 700;
      font-size: 18px;
      color: @lightdark;
      line-height: 20px;
      cursor: pointer;
      .transition(all 0.3s);
      &:after {
        position: absolute;
        content: "";
        left: 0;
        bottom: -5px;
        width: 100%;
        height: 3px;
        //background: @orange;
        .transition(all 0.3s);
      }
      &:hover,
      &.active {
        color: var(--bg-clr);
        &:after {
          bottom: 0;
        }
      }
      &.active {
        font-weight: 700;
      }
    }
  }
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 5;
}

// Card Overflow fix
.casino-card-lists ul li {
  margin: 0 32px 0 0;
  padding: 0;
  list-style-type: none;
}

.casino-card-lang-lists ul {
  margin: 0;
}

.casino-card-lists ul {
  @media (min-width: @sizes[large]) {
    margin-bottom: 20px;
  }
}

.casino-card-lang-lists ul li {
  width: 36px;
  height: 36px;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  overflow: hidden;
  margin: 0 6px 6px 0;
  padding: 0;
  border: 1px solid #bbbbbb;
}

.review-banner-card-top-right h6 {
  margin-bottom: 3px;
}

.new-review-banner-card-top-right h6 {
  margin-bottom: 3px;
}

.review-top-menu ul li a {
  padding: 10px 20px 10px 0;
  font-weight: 400;
  font-size: 16px;
  color: #9b9b9b;
  line-height: 25px;
}

.review-top-menu ul li a:active {
  padding: 10px 20px 10px 0;
  font-weight: 400;
  font-size: 16px;
  color: #9b9b9b;
  line-height: 25px;
}

.rating-wrapper-small .radio-star-total {
  padding-left: 10px;
  line-height: 20px;
}

.casino-card-lists ul li {
  margin: 0 12px 0 0;
  padding: 0;
  list-style-type: none;
  @media (min-width: 374px) {
    margin: 0 16px 0 0;
  }
}

.casino-card-lists__review {
  h6 {
    font-weight: 400;
  }
}

.bonus-card {
  &-logo {
    background: @white !important;
    height: 280px !important;
    a {
      text-align: center;
    }
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      border-radius: 12px 12px 0 0px;
      @media (min-width: @sizes[large]) {
        border-radius: 12px 0 0 12px;
        width: 100%;
      }
    }
    @media (min-width: @sizes[medium]) {
      height: 100% !important;
    }
  }
  &-content {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    @media (min-width: @sizes[medium]) {
      padding: 30px 45px;
    }
    &-top {
      width: 100%;
    }
  }
}

.justify-flex-start {
  justify-content: flex-start !important;
}

.casino-card-bonus {
  @media (min-width: @sizes[md-large]) {
    height: 300px;
  }
}

.offset-md-1 {
  @media (min-width: @sizes[medium]) {
    margin-left: 8.33333%;
  }
}

.play_term_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  .terms_tc {
    margin-bottom: 8px;
  }
  .btn-cust {
    margin: 18px 0 !important;
  }
}
.mx-0 {
  margin-left: 0;
  margin-right: 0;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.sticky-review-card {
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  position: fixed;
  color: @white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: top 0.3s ease-out;
  .rating-wrapper-small {
    @media (min-width: @sizes[large]) {
      display: inline-flex;
      height: 24px;
      border-radius: 50px;
      margin-left: 15px;
      padding: 1px 7px;
      .radio-star-total {
        margin-left: 0;
      }
    }
  }
  .sticky-inner {
    background: var(--primary-btn);
    position: absolute;
    bottom: 0;
    width: 100%;
    max-width: 78.125rem;
    padding: 10px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    flex-wrap: wrap;
    @media (min-width: @sizes[medium]) {
      flex-wrap: nowrap;
    }
    @media (min-width: @sizes[large]) {
      background: @white;
      position: relative;
    }
    .md-rating {
      margin-top: 10px;
      display: none;
      @media (min-width: @sizes[medium]) {
        margin-top: 8px;
        margin-left: -12px;
        display: inline-flex;
        height: 18px;
        border-radius: 50px;
        padding: 1px 7px;
        align-items: stretch;
      }
      .radio-stars {
        height: 14px;
        width: 14px;
        img {
          border-radius: 0;
          vertical-align: text-top;
        }
      }
      .radio-star-total {
        font-size: 14px;
        line-height: 15px;
        padding-left: 0;
        display: inline-flex;
        align-items: center;
        span {
          font-size: 14px;
          line-height: 15px;
        }
      }
      @media (min-width: @sizes[large]) {
        display: none;
      }
    }
    .sticky-text {
      font-size: 0.875rem;
      margin-left: 10px;
      margin-right: auto;
      line-height: 0.75rem;
      width: calc(100% - 60px);
      @media (min-width: @sizes[small]) {
        line-height: unset;
      }
      @media (min-width: @sizes[medium]) {
        width: 100%;
        margin-left: 80px;
      }
      .product-name {
        display: flex;
        padding: 0 0 5px 0;
        @media (min-width: @sizes[medium]) {
          display: none;
        }
        .best-rating {
          margin-left: 8px;
        }
      }
      .sticky-title {
        display: none;
        @media (min-width: @sizes[large]) {
          display: flex;
        }
      }
      .bonus-text {
        font-weight: 900;
        font-size: 0.875rem;
        line-height: 14px;
        @media (min-width: @sizes[small]) {
          line-height: 25px;
        }
        a {
          color: @white;
        }
        @media (min-width: @sizes[medium]) {
          font-size: 0.85rem;
        }
        @media (min-width: @sizes[large]) {
          font-size: 1.625rem;
          a {
            color: @lightdark;
          }
        }
      }
      @media (min-width: @sizes[medium]) {
        font-size: 0.85rem;
      }
      @media (min-width: @sizes[large]) {
        margin-left: 0;
      }
      .terms-conditions {
        @media (min-width: @sizes[large]) {
          padding-top: 5px !important;
        }
        a {
          color: @white;
          @media (min-width: @sizes[large]) {
            color: @lightestp;
          }
        }
      }
    }
    .affliate-logo {
      height: 50px;
      width: 50px;
      min-height: 50px;
      min-width: 50px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.09);
      left: 15px;

      img {
        border-radius: 12px;
      }
      @media (min-width: @sizes[medium]) {
        top: -25px;
        position: absolute;
      }
      @media (min-width: @sizes[large]) {
        width: 85px;
        min-width: 85px;
        height: 85px;
        min-height: 85px;
        top: 0;
        left: 0;
        position: relative;
        margin-right: 30px;
      }
    }
    .sticky-play-btn-large {
      display: none;
      font-size: 18px;
      line-height: 100%;
      margin: auto 2px !important;
      color: @white !important;
      @media (min-width: @sizes[large]) {
        display: block;
        background: var(--primary-btn);
        border-color: var(--primary-btn);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn);
        box-shadow: inset 0 -4px 4px var(--primary-btn);
        min-width: 280px;
        font-weight: 900;
      }
      &:hover {
        background: var(--primary-btn-hover);
        border-color: var(--primary-btn-hover);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
        box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
      }
    }
    .sticky-play-btn-medium {
      display: none;
      font-size: 18px;
      line-height: 100%;
      color: #3672f8 !important;
      @media (min-width: @sizes[medium]) {
        display: block;
        background: @white;
        border-color: var(--primary-btn);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn);
        box-shadow: inset 0 -4px 4px var(--primary-btn);
        box-shadow: none;
        margin: 0;
        min-width: 210px;
        height: 34px;
        margin-left: auto;
      }
      @media (min-width: @sizes[large]) {
        display: none;
      }
      &:hover {
        color: @white;
        background: var(--primary-btn-hover);
        border-color: var(--primary-btn-hover);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
        box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
      }
    }
    .sticky-play-btn-mobile {
      background: @white;
      color: var(--primary-btn);
      color: #3672f8 !important;
      border-color: var(--primary-btn);
      box-shadow: none;
      margin: 0;
      line-height: 100%;
      font-size: 0.75rem;
      width: 78px;
      height: 34px;
      padding: 10px 20px;
      @media (min-width: @sizes[medium]) {
        display: none;
      }
    }
  }
  @media (min-width: @sizes[large]) {
    top: -110px;
    height: 110px;
    background: @white;
    color: @lightdark;
  }
}

.mr-30 {
  margin-right: 30px !important;
}

.minus {
  &:before {
    content: "-";
    font-size: 1.9rem;
  }
}

.h-100 {
  height: 100%;
}

.w-100 {
  width: 100%;
}

.lang-flag {
  height: 34px !important;
  width: 60px !important;
  object-fit: cover;
}

.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}

figure > img {
  height: 100%;
  width: 100%;
}

.md-rating {
  .radio-star-total {
    color: #000 !important;
    font-size: 10px !important;
    line-height: 10px !important;
    span {
      color: #000 !important;
      font-size: 10px !important;
      line-height: 10px !important;
    }
  }
}

.view-mob {
  .span-h1 {
    font-size: 24px !important;
    line-height: 27px !important;
    @media (min-width: @sizes[small]) {
      font-size: 36px !important;
      line-height: 44px !important;
    }
  }
}

.rv-terms {
  display: block;
}

.desk-terms {
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
  a {
    color: #9b9b9b !important;
  }
}

.mob-terms {
  display: block;
  font-size: 0.75rem;
  line-height: 13px;
  width: 100%;
  text-align: center;
  padding: 10px 0 0 0;
  @media (min-width: @sizes[small]) {
    display: none;
  }
  .terms-conditions {
    color: @white;
    a {
      color: @white !important;
      text-decoration: underline !important;
    }
  }
  .mob-cas-term {
    color: @white;
  }
}

.div-term {
  position: absolute;
  background-color: #dfe1e3;
  padding: 10px 12px;
  left: 0;
  width: 100%;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  line-height: 20px;
  position: static;
  width: auto;
  margin: 0px -16px -20px;
  text-align: center;
  @media (min-width: @sizes[medium]) {
    text-align: left;
    position: static;
    width: auto;
    margin: 0px -20px -20px;
  }
  @media (min-width: @sizes[large]) {
    padding: 5px 12px;
    position: static;
    width: auto;
    margin: 0px -30px -30px;
  }
}

.terms-d {
  position: relative;
}

.stick-img {
  img {
    width: 100%;
  }
}

.desk-bonus {
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
}

.mob-bonus {
  display: block;
  @media (min-width: @sizes[small]) {
    display: none;
  }
}

.overall-rating {
  background: @white;
  border: 1px solid #f3f2f5;
  box-shadow: 0 0px 20px 0px rgba(0, 0, 0, 0.05);
  .border-radius(12px);
  .rating-header {
    background: #f7f7f7;
    .border-radius(12px 12px 0px 0px);
    padding: 5px 10px 4px 16px;
    .display-flex();
    .align-items(center);
    .justify-content-space-between();
    @media (min-width: @sizes[large]) {
      padding: 7px 30px 6px 26px;
    }
    h2 {
      font-weight: bold;
      color: #020100;
      margin: 0;
    }
    .rating-count {
      min-width: 65px;
      min-height: 43px;
      .border-radius(7.75px);
      position: relative;
      .comment {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        .border-radius(0 0 7.75px 7.75px);
        font-style: italic;
        font-weight: normal;
        font-size: 10px;
        line-height: 15px;
        text-align: center;
        letter-spacing: -0.03em;
        color: @white;
        padding: 1px 5px;
        display: block;
        box-shadow: 0 0 40px rgba(0, 0, 0, 0.2) inset;
      }
      &-top {
        .display-flex();
        .align-items(center);
        .justify-content-center();
        .value {
          font-weight: bold;
          font-size: 20px;
          line-height: 27px;
          text-align: center;
          letter-spacing: -0.03em;
          color: @white;
          margin-top: 2px;
        }
        .full-star {
          margin-left: 4px;
          width: 14px;
          height: 14px;
          background: #fabf00;
          .border-radius(2px);
          margin-right: 0px;
          position: relative;
          &:after {
            content: " \2605";
            position: absolute;
            top: 50%;
            left: 50%;
            color: #fff;
            font-size: 10px;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
  .progress-bar-block {
    padding: 8px 8px 20px;
    @media (min-width: @sizes[large]) {
      padding: 20px 35px 19px 27px;
    }
    .bar-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        .display-flex();
        .align-items(center);
        .justify-content-space-between();
        margin-bottom: 5px;
        p {
          font-weight: normal;
          color: #222222;
          margin: 0;
        }
        span {
          font-weight: bold;
          font-size: 20px;
          line-height: 30px;
          text-align: right;
          text-transform: capitalize;
          color: #222222;
          .display-flex();
          .align-items(center);
          .full-star {
            margin-left: 8.5px;
            width: 14px;
            height: 14px;
            background: #fabf00;
            .border-radius(2px);
            margin-right: 0px;
            position: relative;
            bottom: 1px;
            &:after {
              content: " \2605";
              position: absolute;
              top: 50%;
              left: 50%;
              color: #fff;
              font-size: 10px;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .bar-rail {
        width: 100%;
        height: 6px;
        background: rgba(206, 205, 205, 0.6);
        .border-radius(52.8455px);
        overflow: hidden;
        .progress-indicator {
          .border-radius(5px);
          height: 6px;
        }
      }
    }
  }
}

.wd-mar {
  width: 100% !important;
  @media (max-width: @sizes[tablet]) {
    margin-left: 0;
  }
}

.cust-span {
  font-size: 24px !important;
  line-height: 27px !important;
  @media (min-width: @sizes[small]) {
    font-size: 32px !important;
    line-height: 40px !important;
  }
}

.ct-btn {
  @media (min-width: @sizes[small]) {
    margin-top: 0px !important;
  }
}

.new-review-banner-card-top-left
.review-left-content
.exclusive-bar-title
.trust
i
img {
  width: 8.35px;
}

@media (min-width: @sizes[medium]) {
  .new-review-banner-card-top-left .review-left-content {
    width: calc(100% - 250px);
  }
}

.rev-terms-condition {
  background: #dfe1e3;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 5px 12px;
  line-height: 20px;
  width: 100%;
  text-align: center;
  @media (min-width: @sizes[medium]) {
    text-align: left;
  }
}

.rm-border {
  @media (min-width: @sizes[md-large]) {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}

.exclu-rev {
  border-bottom-left-radius: 0 !important;
  img {
    border-bottom-left-radius: 0 !important;
  }
}

.soft-i {
  margin-right: 0 !important;
}

.pay-i {
  margin-right: 0 !important;
}

.prod-i {
  margin-right: 0 !important;
}

.sticky-nav-review-block {
  position: sticky;
  display: block;
  z-index: 10;
}

.stripe-sticky {
  display: block !important;
  text-align: center;
  p {
    font-weight: 700;
  }
}

.stripe-sticky {
  position: absolute;
  width: 50px;
  //height: 20px;
  //bottom: 25px;
  top: 50%;
  transform: translateY(6px);
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: @yellow;
  display: none;
  height: 20px;
  line-height: 20px;
  @media (min-width: @sizes[medium]) {
    display: block;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  @media (min-width: @sizes[large]) {
    transform: translateY(25px);
  }
  img {
    width: 14px !important;
    height: 14px !important;
    margin: 3px auto;
    border-radius: 0 !important;
  }
  svg {
    @media (max-width: @sizes[medium]) {
      width: 12px;
    }
  }
}

.desk-excl {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.mob-excl {
  display: block;
  @media (min-width: @sizes[medium]) {
    display: none;
  }
  @media (max-width: @sizes[medium]) {
    display: block;
    margin: 0 auto;
  }
}

.desk-ra-excl {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: flex;
  }
}

.mob-ra-excl {
  display: block;
  @media (min-width: @sizes[medium]) {
    display: none;
  }
}

.exclusive-tag-rev {
  //display: block;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 12px;
  line-height: 15px;
  border-radius: 8px;
  width: 90%;
  bottom: 10px;
  height: 28px;
  display: flex;
  justify-content: center;
  @media (min-width: @sizes[medium]) {
    //display: none;
    bottom: 14px;
    width: 90%;
    font-size: 17px;
    line-height: 28px;
    z-index: 10;
  }
  @media (min-width: @sizes[large]) {
    width: 210px;
    bottom: 10px;
  }
  img {
    width: 18px !important;
    height: 18px !important;
    border-radius: 0 !important;
    object-fit: contain !important;
    margin-right: 5px;
    @media (max-width: 767px) {
      //margin: 8px auto;
    }
  }
  p {
    font-weight: bold;
    font-size: 12px;
    margin: 0;
    display: flex;
    align-items: center;
  }
}

.exclu-rev {
  position: relative;
}

.casino {
  &-card {
    ul {
      &.proslist-rev {
        margin: 0;
        padding: 0;
        list-style: none;
        column-count: 0;
        display: block;
        @media (min-width: @sizes[small]) {
          column-count: 2;
          .flex-wrap(wrap);
          .display-flex();
        }
        li {
          width: 100%;
          text-align: left;
          padding-left: 32px;
          line-height: 25px;
          color: @lightdark;
          margin-bottom: 14px;

          background-size: 15px 15px;
          &:last-child {
            margin-bottom: 0px;
          }
          @media (min-width: @sizes[small]) {
            width: 50%;
          }
          &.pros {
            column-count: unset;
            display: block;
            position: relative;
            //background: url("../images/svg-icons/polygon-green.svg") no-repeat 0 1px;
            &:before {
              position: absolute;
              content: "";
              left: 0;
              top: 0;
              display: inline-block;
              transform: translateY(0px);
              height: 26px;
              width: 26px;
              background: rgba(90, 188, 94, 1) url("~@/assets/images/tick.svg")
              no-repeat;
              border-radius: 100%;
              background-position: center;
              background-size: 14px;
            }
            li {
              width: 100%;
              font-size: 16px;
              line-height: 25px;
              // margin-bottom: 15px;
              margin-bottom: 25px;
              background-position: 0 5px;
              &:last-child {
                margin-bottom: 0px;
              }
            }
          }
          &.cons {
            column-count: unset;
            display: block;
            position: relative;
            //background: url("../images/svg-icons/polygon-orange.svg") no-repeat 0 2px;
            &:before {
              position: absolute;
              content: "";
              left: 0;
              top: 0;
              display: inline-block;
              transform: translateY(0px);
              height: 26px;
              width: 26px;
              background: rgba(90, 188, 94, 1) url("~@/assets/images/tick.svg")
              no-repeat;
              border-radius: 100%;
              background-position: center;
              background-size: 14px;
            }
            li {
              width: 100%;
              font-size: 16px;
              line-height: 25px;
              // margin-bottom: 15px;
              margin-bottom: 25px;

              background-size: 15px 15px;
              &:last-child {
                margin-bottom: 0px;
              }
            }
          }
        }
      }
    }
  }
}

.p-caption {
  font-weight: 700;
  margin-bottom: 0;
}

.casino-card-lists ul li figure img {
  margin: 0;
}

.pt-65 {
  padding-top: 65px;
}

iframe {
  border: 0;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Streams/Streams.vue